<div class="strategy-page" [attr.dir]="dir" (click)="closeMenu()">

  <!-- Hero -->
  <header class="page-hero">
    <div class="page-hero__text">
      <h1 class="page-hero__title">{{ 'Strategies' | navTitle | async }}</h1>
      <p class="page-hero__subtitle">
        {{ dir === 'rtl'
          ? 'استعرض خططك الاستراتيجية، تابع التقدم، وافتح أي استراتيجية بسرعة.'
          : 'Browse your strategic plans, track progress, and open any strategy quickly.' }}
      </p>
    </div>

    @if ('manage' | able: 'Strategy':user) {
      <a class="btn-new-strategy" [routerLink]="['/createStrategy', 0]">
        <i class="fa-solid fa-plus"></i>
        <span>{{ 'new_strategy' | translate }}</span>
      </a>
    }
  </header>

  <!-- Stats -->
  @if (strategies.length) {
    <section class="stats-grid" aria-label="summary">
      <div class="stat-chip">
        <span class="stat-chip__value">{{ strategies.length }}</span>
        <span class="stat-chip__label">{{ dir === 'rtl' ? 'الإجمالي' : 'Total' }}</span>
      </div>
      <div class="stat-chip">
        <span class="stat-chip__value">{{ getDefaultCount() }}</span>
        <span class="stat-chip__label">{{ 'defualt' | translate }}</span>
      </div>
      <div class="stat-chip">
        <span class="stat-chip__value">{{ getStatusCount('active') }}</span>
        <span class="stat-chip__label">{{ 'active' | translate }}</span>
      </div>
      <div class="stat-chip">
        <span class="stat-chip__value">{{ getStatusCount('completed') }}</span>
        <span class="stat-chip__label">{{ dir === 'rtl' ? 'مكتملة' : 'Completed' }}</span>
      </div>
    </section>
  }

  <!-- Toolbar -->
  <section class="toolbar">
    <div class="search-wrapper">
      <i class="fa-solid fa-magnifying-glass search-icon"></i>
      <input
        type="search"
        class="search-input"
        [(ngModel)]="searchTerm"
        [placeholder]="dir === 'rtl' ? 'ابحث باسم الاستراتيجية...' : 'Search by strategy name...'"
        autocomplete="off">
      @if (searchTerm) {
        <button type="button" class="search-clear" (click)="searchTerm = ''" [attr.aria-label]="dir === 'rtl' ? 'مسح' : 'Clear'">
          <i class="fa-solid fa-xmark"></i>
        </button>
      }
    </div>

    <div class="view-toggles" role="group">
      <button
        type="button"
        class="view-btn"
        [class.active]="displayType === 'cards'"
        (click)="displayType = 'cards'">
        <i class="pi pi-th-large"></i>
        <span>{{ 'cards_view' | translate }}</span>
      </button>
      <button
        type="button"
        class="view-btn"
        [class.active]="displayType === 'list'"
        (click)="displayType = 'list'">
        <i class="pi pi-list"></i>
        <span>{{ 'list_view' | translate }}</span>
      </button>
    </div>
  </section>

  <!-- Content -->
  @if (strategies.length) {
    <div class="content-area">
      @if (filteredStrategies.length === 0) {
        <div class="empty-state">
          <div class="empty-state__icon"><i class="fa-solid fa-magnifying-glass"></i></div>
          <p class="empty-state__title">
            {{ dir === 'rtl' ? 'لا نتائج مطابقة' : 'No matching results' }}
          </p>
          <p class="empty-state__text">
            {{ dir === 'rtl' ? 'جرّب كلمة بحث أخرى أو امسح البحث.' : 'Try another keyword or clear the search.' }}
          </p>
          <button type="button" class="empty-state__btn" (click)="searchTerm = ''">
            {{ dir === 'rtl' ? 'مسح البحث' : 'Clear search' }}
          </button>
        </div>
      } @else if (displayType === 'cards') {
        <div class="strategies-grid">
          @for (strategy of filteredStrategies; track strategy.id; let i = $index) {
            <article class="strategy-card" (click)="$event.stopPropagation()">
              <div class="card-top">
                <div class="icon-circle">
                  <i class="fa-solid fa-bullseye"></i>
                </div>

                <div class="card-badges">
                  @if (strategy.is_default) {
                    <span class="status-badge default">
                      <i class="fa-solid fa-star"></i>
                      {{ 'defualt' | translate }}
                    </span>
                  }
                  @if (getStrategyStatus(strategy) === 'active') {
                    <span class="status-badge active">{{ 'active' | translate }}</span>
                  } @else if (getStrategyStatus(strategy) === 'upcoming') {
                    <span class="status-badge upcoming">{{ dir === 'rtl' ? 'قادمة' : 'Upcoming' }}</span>
                  } @else if (getStrategyStatus(strategy) === 'completed') {
                    <span class="status-badge completed">{{ dir === 'rtl' ? 'مكتملة' : 'Completed' }}</span>
                  }
                </div>

                @if ('manage' | able: 'Strategy':user:null) {
                  <div class="menu-dots">
                    <button type="button" class="menu-trigger" (click)="toggleMenu(strategy.id, $event)">
                      <i class="fa-solid fa-ellipsis-vertical"></i>
                    </button>
                    @if (isMenuOpen(strategy.id)) {
                      <div class="menu-dropdown">
                        <button
                          type="button"
                          class="menu-item"
                          [routerLink]="['/createStrategy', strategy.id]"
                          (click)="closeMenu()">
                          <i class="fa-solid fa-pen-to-square"></i>
                          <span>{{ 'edit' | translate }}</span>
                        </button>
                        <button
                          type="button"
                          class="menu-item delete"
                          (click)="confirm($event, strategy.id); closeMenu()">
                          <i class="fa-solid fa-trash-can"></i>
                          <span>{{ 'delete' | translate }}</span>
                        </button>
                      </div>
                    }
                  </div>
                }
              </div>

              <h3 class="strategy-title">{{ strategy.name }}</h3>

              <div class="dates-section">
                <div class="date-item">
                  <i class="fa-regular fa-calendar"></i>
                  <span>{{ 'start_date' | translate }}</span>
                  <strong>{{ strategy.start_date }}</strong>
                </div>
                <div class="date-item">
                  <i class="fa-regular fa-calendar-check"></i>
                  <span>{{ 'end_date' | translate }}</span>
                  <strong>{{ strategy.end_date }}</strong>
                </div>
              </div>

              <div class="progress-section">
                <div class="progress-header">
                  <span class="progress-label">{{ 'progress' | translate }}</span>
                  <span class="progress-value">{{ calculateProgress(strategy) }}%</span>
                </div>
                <div class="progress-bar" role="progressbar" [attr.aria-valuenow]="calculateProgress(strategy)" aria-valuemin="0" aria-valuemax="100">
                  <div class="progress-fill" [style.width.%]="calculateProgress(strategy)"></div>
                </div>
              </div>

              <div class="card-actions">
                <a class="action-link" [routerLink]="['/strategy-alignment', strategy.id]">
                  <i class="fa-solid fa-diagram-project"></i>
                  {{ 'alignment' | translate }}
                </a>
                <a
                  class="btn-open"
                  [routerLink]="['/strategy-manager-home']"
                  [queryParams]="{ strategyId: strategy.id }">
                  {{ 'open' | translate }}
                  <i class="fa-solid fa-arrow-left"></i>
                </a>
              </div>
            </article>
          }
        </div>
      } @else {
        <div class="table-wrapper">
          <p-table [value]="filteredStrategies" styleClass="strategy-table">
            <ng-template pTemplate="header">
              <tr>
                <th>{{ 'name' | translate }}</th>
                <th>{{ 'start_date' | translate }}</th>
                <th>{{ 'end_date' | translate }}</th>
                <th>{{ 'progress' | translate }}</th>
                <th>{{ 'defualt' | translate }}</th>
                <th>{{ 'options' | translate }}</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-strategy>
              <tr [class.is-default-row]="strategy.is_default">
                <td>
                  <div class="table-name">
                    <span class="table-name__icon"><i class="fa-solid fa-bullseye"></i></span>
                    <span>{{ strategy.name }}</span>
                  </div>
                </td>
                <td>{{ strategy.start_date }}</td>
                <td>{{ strategy.end_date }}</td>
                <td>
                  <div class="table-progress">
                    <div class="progress-bar compact">
                      <div class="progress-fill" [style.width.%]="calculateProgress(strategy)"></div>
                    </div>
                    <span>{{ calculateProgress(strategy) }}%</span>
                  </div>
                </td>
                <td>
                  @if (strategy.is_default) {
                    <span class="default-pill">{{ 'yes' | translate }}</span>
                  } @else {
                    <span class="muted">{{ 'no' | translate }}</span>
                  }
                </td>
                <td>
                  <div class="table-actions-row">
                    <a
                      [routerLink]="['/strategy-manager-home']"
                      [queryParams]="{ strategyId: strategy.id }"
                      class="table-action-icon"
                      pTooltip="{{ 'Go_to_Strategy' | translate }}"
                      tooltipPosition="top">
                      <i class="fa-solid fa-rocket"></i>
                    </a>
                    <a
                      [routerLink]="['/strategy-alignment', strategy.id]"
                      class="table-action-icon"
                      pTooltip="{{ 'view_strategic_alignment' | translate }}"
                      tooltipPosition="top">
                      <i class="fa-solid fa-diagram-project"></i>
                    </a>
                    @if ('manage' | able: 'Strategy':user:null) {
                      <a
                        class="table-action-icon"
                        [routerLink]="['/createStrategy', strategy.id]"
                        pTooltip="{{ 'edit' | translate }}"
                        tooltipPosition="top">
                        <i class="fa-solid fa-pen-to-square"></i>
                      </a>
                      <button
                        type="button"
                        class="table-action-icon danger"
                        (click)="confirm($event, strategy.id)"
                        pTooltip="{{ 'delete' | translate }}"
                        tooltipPosition="top">
                        <i class="fa-solid fa-trash-can"></i>
                      </button>
                    }
                  </div>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      }
    </div>
  } @else {
    <app-strategy404></app-strategy404>
  }

  <p-confirmPopup />
  <p-toast />
</div>
